import MFXLocalStorage from 'Helpers/MFXLocalStorage';
import { mainTabLink } from '../Utils/sessionedLinks';

const LinkingElement = props => {
    let inputName = !isNaN(props.designData.Label) ? props.designData.Label : window.Dictionary.getTranslation(props.designData.Label);

    function onClickHandler(index) {
        //window.location.href = '';
        console.log(index);
        if (props.designData.Type === 'order') window.location.href = mainTabLink(`/processes/detailview?type=offer&index=${index}`);
    }

    const addNewTab = (data, idx) => {
        if (!MFXLocalStorage.hasKeyInDB('CUSTOMER_' + idx)) {
            MFXLocalStorage.createTab(
                {
                    primaryId: idx,
                    primaryType: 'customer',
                    context: {customerName: data.Name1},
                },
                true,
                true,
                '/processes/customer',
                '/processes/customer'
            );
        } else {
            MFXLocalStorage.setCurrent('CUSTOMER_' + idx, true, '/processes/customer');
        }
    };

    return (
        <div className={'mfx-input-element mfx-input-text'}>
            {!props.noLabel && props.designData.Label && (
                <label htmlFor={inputName}  style={{ color: props.disableMode ? 'var(--gray)' : 'var(--fontColor)' }}>
                    {!isNaN(props.designData.Label) ? window.Dictionary.getTranslation(props.designData.Label) : props.designData.Label}
                    {props.designData.Required && '*'}
                </label>
            )}
            <div className="mfx-linking-element-wrapper">
                {props.designData?.Type === 'customer' && props.customData?.map(d => <a onClick={() => addNewTab(d, d.CustomerNumber)}>{d.CustomerNumber + ' ' + d.Name1}</a>)}
                {props.designData?.Type === 'order' && props.customData?.map(d => <a onClick={() => onClickHandler(d.Inx)}>{d.OrderNumber + ' ' + (d.Keyword ?? '')}</a>)}
            </div>
        </div>
    );
};

export default LinkingElement;
